/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('screens/overlays/unlock-overlay',['require','core/overlay-screen'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var OverlayScreen = require('core/overlay-screen');
  //var Engine = require('core/engine');

  /*****************************************************************************************************************///}

  var UnlockOverlay = OverlayScreen.extend({

  /////////////
  // METHODS /{
  /////////////

    /*onBeforeShow: function()
    {
      this.medalEl = this.$el.find('[data-id=medal_mc]');
      this.resultTF = this.$el.find('[data-id=result_tf]');
      this.locationTF = this.$el.find('[data-id=location_tf]');
      this.missionTF = this.$el.find('[data-id=mission_tf]');

      var $medal = this.completedModule.medal();
      var $resultContent = $medal === 'medal_none' ? this.model.get('medal_none') : this.model.get('medal_earned');

      this.medalEl.attr('data-medal', $medal);
      this.resultTF.html($resultContent);
      this.locationTF.html(this.completedModule.get('location'));
      this.missionTF.html(this.completedModule.get('description'));

      //console.log('summary show', this.completedModule, this);

      OverlayScreen.prototype.onBeforeShow.apply(this, arguments);
    },*/

    onShow: function()
    {
      if (this.model.get('media'))
        this.playMedia();

      this.finish();
    },

  /*****************************************************************************************************************///}

  });

  return UnlockOverlay;

});

